
import React, {FC} from 'react';
import ReactSlider from 'react-slider';

import * as styles from './styles.module.scss';

type PickerProps = {
	label?: boolean
	defaultValue?: number
	min: number
	max: number
	onChange: (v: number) => void
}

const Picker: FC<PickerProps> = ({
	label = true,
	defaultValue,
	min,
	max,
	onChange,
}) => {
	return (
		<div className={styles.wrapper}>
			{label && (
				<p className={styles.label}>
					Number of scan credits
				</p>
			)}
			<div className={styles.picker}>
				<span>
					{min}
				</span>
				<ReactSlider
					className={styles.slider}
					thumbClassName={styles.thumb}
					trackClassName={styles.track}

					defaultValue={defaultValue || min}
					min={min}
					max={max}
					onChange={onChange}

					renderThumb={(props, state) => (
						<div {...props}>
							<div className={styles.circle} />
							<div className={styles.text}>
								{state.valueNow}
							</div>
						</div>
					)}
				/>
				<span>
					{max}
				</span>
			</div>
		</div>
	);
};

export default Picker;
